import type { ProductSelection } from "@/types/coverage";

interface OriginalResult {
  box?: { points: number[][] };
  product_selection?: ProductSelection;
  empty_areas?: Array<{ points: number[][] }>;
  product_selections?: ProductSelection[];
}

/** Extract box points from original result — tries simplified format first, then falls back to empty_areas[0]. */
export function extractBoxPoints(originalResult: OriginalResult | undefined | null): number[][] | null {
  if (originalResult?.box?.points) {
    return originalResult.box.points;
  }
  if (originalResult?.empty_areas?.[0]?.points) {
    return originalResult.empty_areas[0].points;
  }
  return null;
}

/** Extract original product selection — tries simplified format first, then falls back to product_selections[0]. */
export function extractOriginalProductSelection(originalResult: OriginalResult | undefined | null): ProductSelection | null {
  if (originalResult?.product_selection) {
    return originalResult.product_selection;
  }
  if (originalResult?.product_selections?.[0]) {
    return originalResult.product_selections[0];
  }
  return null;
}
